<template>
  <div ref="modalw" class="modal-wrapper" >
      <div class="TryModalPage">
        <div class="title">
          立即咨询<br>
          开启数智化之旅
        </div>
        <a-form class="form" :form="form" @submit="handleSubmit">
          <a-form-item>
            <a-input
              v-decorator="[
                'company',
                { rules: [{ required: true, message: '请输入公司名称!' }] },
              ]"
              placeholder="公司名称"
            />
            <div  style="color: red;position: absolute;right: -20px;">*</div>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'industry',
                { rules: [{ message: '请输入所在行业!' }] },
              ]"
              placeholder="请输入所在行业"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'address',
                { rules: [{ message: '请输入所在城市!' }] },
              ]"
              placeholder="请输入所在城市"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="['name', { rules: [{ required: true, message: '请输入姓名!' }] }]"
              placeholder="输入联系人姓名"
            />
            <div  style="color: red;position: absolute;right: -20px;">*</div>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="['phone', { rules: [{
                required: true,
                message: '请输入手机号!'
              }, {
                validator: checktelphone,
              }] }]"
              placeholder="输入手机号码"
            />
            <div  style="color: red;position: absolute;right: -20px;">*</div>
          </a-form-item>
          <a-form-item>
            <a-input-search
              v-decorator="['verifyCode', { rules: [{ required: true, message: '请输入短信验证码!' }] }]"
              placeholder="短信验证码"
              size="large"
              @search="getVerificationCode"
            >
              <a-button slot="enterButton" :disabled="!isShowGetCode">
                <template v-if="isShowGetCode">获取验证码</template>
                <template v-else>{{ countdown }}s后可重试</template>
              </a-button>
            </a-input-search>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'informationExplain',
              ]"
              :style="{
                height: '100px'
              }"
              type="textarea"
              placeholder="如果您对我们的产品有任何问题，可以留下咨询信息"
            />
          </a-form-item>
          <a-form-item>
            <div class="statement">
              隐私声明：<br>
              接受通过此手机接收相关的产品信息和咨询，汇通数科不会将您的信息进行商用或者透露给第三方，请放心填写。
            </div>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit" class="submit-btn">
              提交申请
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    <div id="captcha" />
  </div>
</template>

<script>
import { infomationAdd, sendSmsCaptcha } from '@/apis/index'
  import metaInfo from '@/common/util/metaInfo'

export default {
    metaInfo: metaInfo.TryModalPage,

  name: 'TryModalPage',
  props: {

  },
  data() {
    return {
      infoSources: this.$route.query.title,
      form: this.$form.createForm(this),
      countdown: 60,
      timer: '',
      isShowGetCode: true,
      scrollerHeight: '',
      captcha: null

    }
  },
  mounted() {
    this.getCode()
    console.log('当前页面：', this.$route.query.title)
    const originalHeight = document.documentElement.clientHeight || document.body.clientHeight
    window.onresize = () => {
      return (() => {
        // 键盘弹起与隐藏都会引起窗口的高度发生变化
        const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
        console.log('进入到判断页面高度=========')
        console.log('页面初始高度=========' + originalHeight)
        console.log('软键盘弹起高度=========' + resizeHeight)
        if (resizeHeight - 0 < originalHeight - 0) {
          // 当软键盘弹起，在此处操作
          console.log('进入到软键盘弹起=========')
          document.querySelector('body').setAttribute('style', 'height:' + originalHeight + 'px;')
          this.scrollerHeight = resizeHeight
        } else {
          // 当软键盘收起，在此处操作
          console.log('进入到软键盘收起=========')
          document.querySelector('body').setAttribute('style', 'height:100%;')
          this.scrollerHeight = '100%'
        }
      })()
    }
  },
  methods: {
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/
      if (value && !(reg.test(value))) {
        callback('请输入正确的手机号码！')
      } else {
        callback()
      }
    },
    getVerificationCode() {
      this.form.validateFields(['imgCaptcha', 'phone'], (errors, values) => {
        if (!errors) {
          this.params = values
          this.captchaIns.popUp()
        }
      })
    },
    getCode() {
      const that = this
      // eslint-disable-next-line no-undef
      initNECaptcha && initNECaptcha({
        element: '#captcha',
        captchaId: '6c0483e901164a789d9d13f0291ba257',
        mode: 'popup',
        width: '320px',
        // enableClose: true,
        onClose: function() {
          // 弹出关闭结束后将会触发该函数
        },
        onVerify: function(err, data) {
          if (err) return
          // that.captchaIns.close()
          that.params.pictureCode = data.validate
          sendSmsCaptcha(that.params).then(data => {
            that.countDown()
            that.isShowGetCode = false
          }).catch(err => {
            that.$message.error(err)
            that.captchaIns.refresh()
          })
        }
      }, function(instance) {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        that.captchaIns = instance
      }, function(err) {
        console.log(err)
        // 初始化失败后触发该函数，err对象描述当前错误信息
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            infoSources: '汇通数科官网-' + this.infoSources,
            officialWebsiteEntrance: '公众号',
            company: values.company,
            industry: values.industry,
            address: values.address,
            name: values.name,
            phone: values.phone,
            verifyCode: values.verifyCode,
            informationExplain: values.informationExplain
          }
          infomationAdd(params).then(res => {
            this.$message.success({
              content: '感谢您的信息提交，我们将会有专员与您联系~',
              duration: 1
            })
            this.form.resetFields()
            this.captchaIns.refresh()
            this.$emit('cancel', false)
          }).catch(err => {
            this.$message.error(err)
            this.captchaIns.refresh()
          })
        }
      })
    },
    handleCancel(e) {
      this.$emit('cancel', false)
    },
    sendMessage() {
      this.form.validateFields(['phone'], (errors, values) => {
        if (!errors) {
          sendSmsCaptcha(values).then(data => {
            this.countDown()
            this.isShowGetCode = false
          }).catch(err => {
            this.$message.error(err)
          })
        }
      })
    },
    countDown() {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.modal-wrapper{
  padding: 40px;
    background: #FFFFFF;

}
.TryModalPage{
margin-top: 20px;
}
/deep/.ant-form-item-children{
    display: flex;
  }
  .title {
    height: 48px;
    font-size: 16px;
    font-weight: 600;
    color: #222222;
    line-height: 24px;
    margin-bottom: 16px;
  }
  /deep/ .ant-modal-body {
    padding: 12px 18px;
  }
  .form {
    // width: 273px;
    margin: 0 auto;
  }
  /deep/ .ant-select-selection--single {
    height: 40px;
  }
  /deep/ .ant-select-selection__rendered {
    line-height: 40px;
  }
  /deep/ .ant-input {
    height: 40px;
  }
  /deep/ .ant-btn-lg {
    height: 40px;
    background: #F9FBFD;
  }
  /deep/ .submit-btn {
    width: 100%;
    height: 37px;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 600;
    color: #FFFFFF;
  }
  .statement {
    font-size: 14px;
    font-weight: 400;
    color: #8B8FA1;
    line-height: 22px;
  }
  .count-down {
    background: #F9FBFD;
    color: rgba(0, 0, 0, 0.65);
    width: 112px;
  }
</style>
